var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"member-pie-chart-wrap"},[(_vm.tabName === 'pieChart')?_c('pie',{attrs:{"tabName":_vm.navName,"siteId":_vm.siteId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }